import React from 'react';
import Header from '../include/Header';
import Footer from '../include/Footer';

import {Container, Form, Button} from 'react-bootstrap';

function Contact() {
  return (
    <div>
        <Header />

        <section className='contact-section ptb-80'>
          <Container className='relative'>
            <h2>Contact</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco  laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
          </Container>
        </section>

        <Footer />
    </div>
    
  )
}

export default Contact